<div id="copies" *ngIf="copyMessages">
  <div *ngIf="copyMessages.length === 1" class="copy-message">
    <strong *ngIf="!isFromUnknownContact(copyMessages[0])">{{ copyMessages[0].copyGuest.firstName }}</strong>
    <strong *ngIf="isFromUnknownContact(copyMessages[0])">{{ 'agent:contact.info.unknown_contact' | translate | uppercase }}</strong>
    <time>{{ copyMessages[0].copyGuest.date | date: 'HH:mm' }}</time>
    <div class="copy" *ngIf="copyMessages[0].copyGuest">{{ 'agent:panel.chat.copy.copy' | translate }}</div>
    <p [innerHTML]="getMessageContent(copyMessages[0].content)"></p>
  </div>
  <div *ngIf="copyMessages.length > 1">
    <div class="copy-header">
      <button (click)="toggle()" [ngClass]="expanded ? 'cng-ico_menu_open' : 'cng-ico_menu_close'" class="action-button"></button>
      <div class="copy-label">
        {{ 'agent:panel.chat.copy.chat_between' | translate: { customer: customerName, agent: csrName } }}
      </div>
      <div class="copy" *ngIf="copyMessages[0].copyGuest">{{ 'agent:panel.chat.copy.copy' | translate }}</div>
    </div>
    <div *ngIf="expanded">
      <div *ngFor="let copyMsg of copyMessages" class="message-div">
        <strong *ngIf="!isFromUnknownContact(copyMsg)">{{ copyMsg.copyGuest.firstName }}</strong>
        <strong *ngIf="isFromUnknownContact(copyMsg)">{{ 'agent:contact.info.unknown_contact' | translate | uppercase }}</strong>
        <time>{{ copyMsg.copyGuest.date | date: 'HH:mm' }}</time>
        <p [innerHTML]="getMessageContent(copyMsg.content)"></p>
      </div>
    </div>
  </div>
</div>
